import { Box, Button, Card, CardActions, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import AdminMerchantWalletDialog from './AdminMerchantWalletDialog'

export default function MerchantBalanceCard({ wallet, merchantId, profileRefetch }) {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <AdminMerchantWalletDialog
                open={open}
                balance={wallet?.balance}
                onClose={(refetch) => {
                    setOpen(false)
                    if (refetch) {
                        profileRefetch()
                    }
                }}
                merchantId={merchantId}
            />
            <CardHeader title={t("Wallet Balance")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <Grid container spacing={2}>
                    <Grid item md={6} xs={6}>
                        <Box>
                            <Typography sx={{ fontWeight: "bold" }}>
                                {t("Current Balance")}
                            </Typography>
                            <Typography>
                                {wallet?.balance?.toFixed(2)}
                            </Typography>
                        </Box>
                    </Grid>
                    {/* <Grid item md={6} xs={6}>
                        <Box>
                            <Typography sx={{ fontWeight: "bold" }}>
                                {t("Amount Withdrawn")}
                            </Typography>
                            <Typography>
                                {wallet?.amountWithdrawn?.toFixed(2)}
                            </Typography>
                        </Box>
                    </Grid> */}
                </Grid>
            </CardContent>
            <Divider />
            <CardActions>
                <Box mr="auto" />
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setOpen(true)}
                    sx={{ textTransform: "none" }}
                >
                    {t("Credit/Debit Wallet")}
                </Button>
            </CardActions>
        </Card>
    )
}
